import { put } from "@redux-saga/core/effects";

import { addBulkOptionsFailure, addBulkOptionsSuccess } from "../actionCreaters";

import { FieldsService } from "./../../../services/fields";
import { optionsResponse, AddBulkOptionRequestActionType } from "./../types";

export function* addBulkOptionsSaga({ payload: { fieldId, options } }: AddBulkOptionRequestActionType) {
    try {
        const {
            data: { data },
        }: optionsResponse = yield FieldsService.addBulkOptions(fieldId, options);

        yield put(addBulkOptionsSuccess({ fieldId, options: data.options }));
    } catch (error) {
        yield put(addBulkOptionsFailure({ fieldId }));
    }
}
